import React, {useState} from 'react';
import {Typography, Box} from '@mui/material';

const countryDictionary = {
    BR: { country_name: "Brazil", country_flag: "🇧🇷" },
    IN: { country_name: "India", country_flag: "🇮🇳" },
    GB: { country_name: "Great Britain", country_flag: "🇬🇧" },
    US: { country_name: "United States", country_flag: "🇺🇸" },
    CA: { country_name: "Canada", country_flag: "🇨🇦" },
    AR: { country_name: "Argentina", country_flag: "🇦🇷" },
    AU: { country_name: "Australia", country_flag: "🇦🇺" },
    AT: { country_name: "Austria", country_flag: "🇦🇹" },
    BE: { country_name: "Belgium", country_flag: "🇧🇪" },
    CL: { country_name: "Chile", country_flag: "🇨🇱" },
    CN: { country_name: "China", country_flag: "🇨🇳" },
    CO: { country_name: "Colombia", country_flag: "🇨🇴" },
    HR: { country_name: "Croatia", country_flag: "🇭🇷" },
    DK: { country_name: "Denmark", country_flag: "🇩🇰" },
    DO: { country_name: "Dominican Republic", country_flag: "🇩🇴" },
    EG: { country_name: "Egypt", country_flag: "🇪🇬" },
    FI: { country_name: "Finland", country_flag: "🇫🇮" },
    FR: { country_name: "France", country_flag: "🇫🇷" },
    DE: { country_name: "Germany", country_flag: "🇩🇪" },
    GR: { country_name: "Greece", country_flag: "🇬🇷" },
    HK: { country_name: "Hong Kong", country_flag: "🇭🇰" },
    ID: { country_name: "Indonesia", country_flag: "🇮🇩" },
    IE: { country_name: "Ireland", country_flag: "🇮🇪" },
    IL: { country_name: "Israel", country_flag: "🇮🇱" },
    IT: { country_name: "Italy", country_flag: "🇮🇹" },
    JP: { country_name: "Japan", country_flag: "🇯🇵" },
    JO: { country_name: "Jordan", country_flag: "🇯🇴" },
    KW: { country_name: "Kuwait", country_flag: "🇰🇼" },
    LB: { country_name: "Lebanon", country_flag: "🇱🇧" },
    MY: { country_name: "Malaysia", country_flag: "🇲🇾" },
    MX: { country_name: "Mexico", country_flag: "🇲🇽" },
    NL: { country_name: "Netherlands", country_flag: "🇳🇱" },
    NZ: { country_name: "New Zealand", country_flag: "🇳🇿" },
    NG: { country_name: "Nigeria", country_flag: "🇳🇬" },
    NO: { country_name: "Norway", country_flag: "🇳🇴" },
    PK: { country_name: "Pakistan", country_flag: "🇵🇰" },
    PA: { country_name: "Panama", country_flag: "🇵🇦" },
    PE: { country_name: "Peru", country_flag: "🇵🇪" },
    PH: { country_name: "Philippines", country_flag: "🇵🇭" },
    PL: { country_name: "Poland", country_flag: "🇵🇱" },
    RU: { country_name: "Russia", country_flag: "🇷🇺" },
    SA: { country_name: "Saudi Arabia", country_flag: "🇸🇦" },
    RS: { country_name: "Serbia", country_flag: "🇷🇸" },
    SG: { country_name: "Singapore", country_flag: "🇸🇬" },
    ZA: { country_name: "South Africa", country_flag: "🇿🇦" },
    KR: { country_name: "South Korea", country_flag: "🇰🇷" },
    ES: { country_name: "Spain", country_flag: "🇪🇸" },
    SE: { country_name: "Sweden", country_flag: "🇸🇪" },
    CH: { country_name: "Switzerland", country_flag: "🇨🇭" },
    TW: { country_name: "Taiwan", country_flag: "🇹🇼" },
    TH: { country_name: "Thailand", country_flag: "🇹🇭" },
    TR: { country_name: "Turkey", country_flag: "🇹🇷" },
    AE: { country_name: "United Arab Emirates", country_flag: "🇦🇪" },
    VE: { country_name: "Venezuela", country_flag: "🇻🇪" },
    PT: { country_name: "Portugal", country_flag: "🇵🇹" },
    LU: { country_name: "Luxembourg", country_flag: "🇱🇺" },
    BG: { country_name: "Bulgaria", country_flag: "🇧🇬" },
    CZ: { country_name: "Czech Republic", country_flag: "🇨🇿" },
    SI: { country_name: "Slovenia", country_flag: "🇸🇮" },
    IS: { country_name: "Iceland", country_flag: "🇮🇸" },
    SK: { country_name: "Slovakia", country_flag: "🇸🇰" },
    LT: { country_name: "Lithuania", country_flag: "🇱🇹" }
    // Add more countries as needed
};

function Segmentacion({selectedPost}) {
    // Split the countries string into an array
    // const countriesArray = selectedPost?.countries?.split(',') || [];
    const countriesArray = selectedPost?.data?.countries || [];
    const agesArray = selectedPost?.data?.ageRanges || [];
    const totalFemales = selectedPost?.data?.totalFemales || 0;
    const totalMales = selectedPost?.data?.totalMales || 0;
   /* console.log("countriesArray", countriesArray);
    console.log("agesArray", agesArray);
    console.log("totalFemales", totalFemales);
    console.log("totalMales", totalMales);*/


    const getCountryDetails = (country_code) => {
        return countryDictionary[country_code] || { country_name: "Unknown", country_flag: "🏳️" };
    };
    
    //let countriesArray;
    let ages;
    // si se vino de landings
    if(Array.isArray(selectedPost?.countries)){
        //countriesArray = extractCountryValues(selectedPost?.countries)
        ages =  selectedPost?.age.join(" - ")

    } else {
        //se viono de la busqueda convencional
        //countriesArray = selectedPost?.countries !== "" ? selectedPost?.countries?.split(',') : "";    
        ages =  selectedPost?.age
    }

    
    
    
    // Determine if we need to show the "Ver más" option
    const [showAllCountries, setShowAllCountries] = useState(false);
    const displayCountries = showAllCountries ? countriesArray : countriesArray.slice(0, 5);

    const handleShowMoreClick = () => {
        setShowAllCountries(!showAllCountries);
    };

    // Translate gender
    const translateGender = (gender) => {
        switch (gender) {
            case 'All':
                return 'Todos';
            case 'Men':
                return 'Hombres';
            case 'Women':
                return 'Mujeres';
            default:
                return 'No especificado';
        }
    };

    return (
        // <Box padding="20px" border="1px solid black" borderRadius="4px" maxWidth="300px">
        <Box border="1px solid black" borderRadius="4px" sx={{p: 2, m: 1}}>
            <Typography fontSize="24px" fontWeight="bold" mb={1}>
                Segmentación
            </Typography>
            <Box borderBottom="1px solid black" mb={2}></Box>

            {/* Edad */}
            <Box display="flex" alignItems="center" mb={1}>
                <Typography fontWeight="bold" mr={1}>
                    Edad:
                </Typography>
                <Typography>{agesArray.length > 0 ? agesArray.join(', ') : 'No especificado'}</Typography>
            </Box>

            {/* Países */}
            {
                countriesArray.length >= 1 && (
                    <Box display="flex" alignItems="top" mb={1}>
                        <Typography fontWeight="bold" mr={1}>
                            Países:
                        </Typography>
                        <Box>
                            {displayCountries.map((country, index) => {
                                const { country_name, country_flag } = getCountryDetails(country);
                                return (
                                    country_name !== "Unknown" && (
                                        <Typography key={index}>
                                            {country_flag} {country_name}
                                        </Typography>
                                    )
                                );
                            })}

                            {countriesArray.length > 5 && (
                                <Typography
                                    onClick={handleShowMoreClick}
                                    sx={{fontWeight: 'bold', cursor: 'pointer', color: 'blue'}}>
                                    {showAllCountries ? 'Ver menos...' : 'Ver más...'}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                )
            }

            {/* Género */}
            <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" mr={1}>
                    Género:
                </Typography>
                <Typography>{totalFemales > 0 ? "Mujeres" : "" } {totalMales>0 ? "Hombres" : ""}</Typography>
            </Box>
        </Box>
    );
}

function extractCountryValues(countriesArray) {
    return countriesArray.map(countryObj => countryObj.country);
}

export default Segmentacion;
